import React, { useState } from 'react';
import { useT } from 'client/i18n/hooks/useT';
import { AnchorAPI } from 'modules/AnchorAPI';
import { WarningIcon } from 'shared/WarningIcon';
import { paths } from 'client/shared/Paths';
import { ResendTrigger, WarningMessage } from '../WarningMessage/index';

export function ResendEmailWarning({ userId }: { userId: number }) {
  const t = useT();
  const [verificationSent, setVerificationSent] = useState(false);
  const [verificationFailed, setVerificationFailed] = useState(false);

  const resendVerificationEmail = () => {
    return AnchorAPI.resendVerificationEmail({ userId })
      .then(() => {
        setVerificationSent(true);
        setVerificationFailed(false);
      })
      .catch((_error: Error) => {
        // eslint-disable-next-line no-console
        console.warn(_error);
        setVerificationFailed(true);
      });
  };

  return (
    <WarningMessage>
      <WarningIcon />
      <span>
        {verificationFailed ? (
          <>
            {t(
              'ResendEmailWarning.ErrorMessage',
              'Something went wrong sending your email. Try again or visit {helpPageLink} for more assistance.',
              'Resend verification email error message',
              {
                helpPageLink: (
                  <a href={paths.getHelpPage('home')}>
                    {paths.getHelpPage('home')}
                  </a>
                ),
              }
            )}
          </>
        ) : (
          t(
            'ResendEmailWarning.Message',
            "Before you can publish any episodes, you'll need to verify your email address with Anchor.",
            'Resend verification email message'
          )
        )}
      </span>
      <ResendTrigger onClick={resendVerificationEmail}>
        {verificationSent
          ? t(
              'ResendEmailWarning.SentButtonLabel',
              'Sent!',
              'Email sent button text'
            )
          : t(
              'ResendEmailWarning.ResendEmailButtonLabel',
              'Resend email',
              'Resend email button text'
            )}
      </ResendTrigger>
    </WarningMessage>
  );
}
